<template>
    <span></span>
</template>

<script>
export default {
    name: 'StoreFeeder',

    props: {
        storeJson: String,
        storeKey: String,
    },

    beforeCreate ()
    {
        const props = this.$options.propsData;
        if (props.storeKey && props.storeJson)
        {
            this.$store.commit('INIT_STORE', [props.storeKey, JSON.parse(props.storeJson)]);
        }
    },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/store-feeder.vue